import axios from "axios";
import API_CONFIG from "../config/apiConfig";
import { languages, defaultLanguage } from "../i18n/translations";

const API_BASE_URL = API_CONFIG.FULL_API_BASE_URL;

// 获取当前保存的语言
function getCurrentLanguage() {
    const saved = localStorage.getItem("family_dkp_language");
    if (saved && languages.some((l) => l.code === saved)) {
        return saved;
    }
    return defaultLanguage;
}

// 创建 axios 实例
const apiClient = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true, // 发送 cookie
    headers: {
        "Content-Type": "application/json",
    },
});

// 请求拦截器：自动添加 language 参数
apiClient.interceptors.request.use(
    (config) => {
        const lang = getCurrentLanguage();
        const data = config.data;

        // 如果请求体是对象，添加 language 字段
        if (data && typeof data === "object" && !Array.isArray(data)) {
            config.data = {
                ...data,
                language: lang,
            };
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

// 响应拦截器
apiClient.interceptors.response.use(
    (response) => response.data,
    (error) => {
        // 401 错误由 ProtectedRoute 组件处理，不在此处跳转
        // 避免强制刷新页面导致地址栏异常
        return Promise.reject(error);
    },
);

// API 调用函数
export const userApi = {
    getInfo: () => apiClient.get("/user/info.php"),
    updateNickname: (nickname) => apiClient.post("/user/nickname.php", { nickname }),
    updateAvatar: (avatar_id) => apiClient.post("/user/avatar.php", { avatar_id }),
};

export const projectApi = {
    getList: () => apiClient.get("/projects/index.php"),
    create: (data) => apiClient.post("/projects/create.php", data),
    update: (data) => apiClient.post("/projects/update.php", data),
    close: (projectId) => apiClient.post("/projects/close.php", { project_id: projectId }),
    getLogs: (projectId) => apiClient.get(`/logs/index.php?project_id=${projectId}`),
    getPresets: (projectId) => apiClient.get(`/presets/index.php?project_id=${projectId}`),
    savePresets: (projectId, presets) => apiClient.post("/presets/update.php", { project_id: projectId, presets }),
    getInvites: () => apiClient.get("/projects/invites.php"),
    respondInvite: (projectId, action) => apiClient.post("/projects/respond.php", { project_id: projectId, action }),
    getStats: (projectId, period) => apiClient.get(`/projects/stats.php?project_id=${projectId}&period=${period}`),
};

export const logApi = {
    create: (data) => apiClient.post("/logs/create.php", data),
    confirm: (logId) => apiClient.post(`/logs/confirm.php?log_id=${logId}`),
    reject: (logId) => apiClient.post(`/logs/reject.php?log_id=${logId}`),
    withdraw: (logId) => apiClient.delete(`/logs/delete.php?id=${logId}`),
};

export default apiClient;
